import { registerApplication, start } from "single-spa";
import {
  constructApplications,
  constructLayoutEngine,
  constructRoutes,
} from "single-spa-layout";

const rootEl = document.getElementById("single-spa-container-el");
const config = {
  mode: "history",
  containerEl: rootEl,
  routes: [
    {
      type: "application",
      name: "mfe-2-ext-container",
    },
    {
      type: "route",
      path: "**",
      routes: [
        {
          type: "application",
          name: "mfe-2-ext-container",
        },
      ],
      default: false,
    },
    {
      type: "route",
      path: "pioneer-eop-container/starter",
      routes: [
        {
          type: "application",
          name: "mfe2-starter",
        },
      ],
      default: false,
    },
    {
      type: "route",
      path: "pioneer-eop-container/rfi",
      routes: [
        {
          type: "application",
          name: "signals-rfi",
        },
      ],
      default: false,
    },
    {
      type: "route",
      path: "pioneer-eop-container/pending-requests",
      routes: [
        {
          type: "application",
          name: "pioneer-rfi",
        },
      ],
      default: false,
    },
    {
      type: "route",
      path: "pioneer-eop-container/ta-investor",
      routes: [
        {
          type: "application",
          name: "transfer-agency-investor-app",
        },
      ],
      default: false,
    },
    {
      type: "route",
      path: "pioneer-eop-container/pending-requests",
      routes: [
        {
          type: "application",
          name: "pioneer-rfi",
        },
      ],
      default: false,
    },
    {
      type: "route",
      path: "pioneer-eop-container/secure-submit",
      routes: [
        {
          type: "application",
          name: "secure-submit-app",
        },
      ],
      default: false,
    },
    {
      type: "route",
      path: "pioneer-eop-container/borp-app-ext",
      routes: [
        {
          type: "application",
          name: "borp-app-ext",
        },
      ],
      default: false,
    },
    {
      type: "route",
      path: "pioneer-eop-container/kyc-as-a-service",
      routes: [
        {
          type: "route",
          path: "pending-requests",
          routes: [
            {
              type: "application",
              name: "pioneer-rfi",
            },
          ],
          default: false,
        },
        {
          type: "route",
          routes: [
            {
              type: "application",
              name: "kyc-as-a-service-mfe",
            },
          ],
          default: true,
        },
      ],
      default: false,
    },
  ],
};

const showErrorMessage = () => {
  const errorBlock = document.getElementById("loading-error-msg");
  if (!!errorBlock) {
    errorBlock.style.display = "block";
  }
};

const loadAppWhenContainerReady = (name) => {
  return new Promise((resolve, reject) => {
    const intervalId = setInterval(() => {
      const savedContext = window.sessionStorage.getItem("mfev2Context");
      if (!window._mfev2_attempts) window._mfev2_attempts = 0;
      window._mfev2_attempts++;
      if (window._mfev2_attempts > 60) {
        clearInterval(intervalId);
        showErrorMessage();
        reject("Timed out while trying to load application.");
        return;
      }
      if (savedContext) {
        if (name === "mfe-2-ext-container") {
          clearInterval(intervalId);
          System.import(name)
            .then((module) => {
              resolve(module);
            })
            .catch((error) => {
              showErrorMessage();
              reject(error);
            });
        } else {
          const isUserLoaded = JSON.parse(savedContext).extUserInfo?.status;
          if (
            isUserLoaded === "SUCCESS" ||
            window.location.href.includes("localhost")
          ) {
            if (!window._mfev2_attempts) window._mfev2_attempts = 0;
            window._mfev2_attempts++;
            if (window._mfev2_attempts < 60) {
              clearInterval(intervalId);
            } else {
              showErrorMessage();
              reject("An error has occured in loading the application.");
            }
            System.import(name)
              .then((module) => {
                resolve(module);
              })
              .catch((error) => {
                showErrorMessage();
                reject(error);
              });
          } else if (isUserLoaded === "ERROR") {
            showErrorMessage();
            reject("Timed out while trying to load application.");
          }
        }
      }
    }, 500);
  });
};
let applications;
const intervalId = setInterval(() => {
  const savedContext = window.sessionStorage.getItem("mfev2Context");
  if (savedContext) {
    const routes = constructRoutes(config); // construct routes
    clearInterval(intervalId);
    applications = constructApplications({
      routes,
      loadApp({ name }) {
        return loadAppWhenContainerReady(name);
      },
    });
    // pass the base href to the container app as props
    applications.find((app) => app.name === "mfe-2-ext-container").customProps =
      {
        baseHref: "/pioneer-eop-container",
      };

    const layoutEngine = constructLayoutEngine({ routes, applications });

    applications.forEach(registerApplication);
    layoutEngine.activate();
    start();
  }
}, 500);
